import * as React from "react";
import { IAuthor } from "~/types/author";
import Icon from "../icons/icon";
import AuthorImage from "../author-image/author-image";
import Tabs, { ITab } from "~/components/tabs/tabs";
import TabMenu from "~/components/tabs/tab-menu/tab-menu";
import TabContentContainer from "~/components/tabs/tab-content-container/tab-content-container";
import TabContent from "~/components/tabs/tab-content/tab-content";
import classNames from "classnames";
import AuthorPressPhotos from "../author-press-photos/author-press-photos";

export interface AuthorDetailsProps extends IAuthor {
    descriptionTab: string;
    pressPhotosTab: string;
}

const enum tabTypes {
    DESCRIPTION = "description",
    PHOTOS = "photos"
}

const AuthorDetails = ({
    name,
    imageUrl,
    description,
    descriptionTab,
    pressPhotosTab,
    pressPhotosDescription,
    pressPhotos
}: AuthorDetailsProps) => {
    const baseClass = "author-details";

    const tabs: ITab[] = [
        {
            key: tabTypes.DESCRIPTION,
            label: descriptionTab,
            content: (
                <>
                    {description && (
                        <div
                            className={`${baseClass}__description`}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    )}
                </>
            )
        },
        {
            key: tabTypes.PHOTOS,
            label: pressPhotosTab,
            content: (
                <>
                    {pressPhotos && pressPhotos.length ? (
                        <AuthorPressPhotos
                            pressPhotosDescription={pressPhotosDescription}
                            pressPhotos={pressPhotos}
                        />
                    ) : (
                        "Gyldendal råder desværre ikke over et forfatterfoto, der må bruges eksternt."
                    )}
                </>
            )
        }
    ];

    return (
        <section className={baseClass}>
            <div className={`${baseClass}__inner`}>
                <div className={`${baseClass}__image-section`}>
                    <div className={`${baseClass}__image-section-inner`}>
                        <div className={classNames(`${baseClass}__graphics`)}></div>
                        <AuthorImage className={`${baseClass}__author-image`} imageUrl={imageUrl} />
                        <div
                            className={classNames(`${baseClass}__graphics`, `${baseClass}__graphics--quote`)}
                        >
                            <Icon iconId="icon_80x48_quotation-mark" viewBox="0 0 80 48" />
                        </div>
                    </div>
                </div>

                <div className={`${baseClass}__text-section`}>
                    <div className={`${baseClass}__name`}>
                        <h1 className="h1-style">{name}</h1>
                    </div>

                    <Tabs
                        className={`${baseClass}__tabs`}
                        defaultTab={tabs[0]}
                        render={({ tabClickHandler, selectedTabKey }) => (
                            <>
                                <TabMenu
                                    tabClickHandler={tabClickHandler}
                                    tabs={tabs}
                                    selectedKey={selectedTabKey}
                                />
                                <TabContentContainer>
                                    {tabs.map(tab => (
                                        <TabContent isCurrent={selectedTabKey === tab.key} key={tab.key}>
                                            {tab.content}
                                        </TabContent>
                                    ))}
                                </TabContentContainer>
                            </>
                        )}
                    />
                </div>
            </div>
        </section>
    );
};

export default AuthorDetails;
